var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5393_11034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7144 3.00051C22.7334 3.01373 26.58 4.63403 29.3971 7.50037H24.7142C23.8858 7.50037 23.2143 8.1719 23.2143 9.0003C23.2143 9.82869 23.8858 10.5002 24.7142 10.5002H30.9285C32.4665 10.4994 33.7131 9.25278 33.7139 7.71482V1.50051C33.7139 0.672114 33.0424 0.000580654 32.214 0.000580654C31.3856 0.000580654 30.7141 0.672114 30.7141 1.50051V4.61744C23.339 -2.02457 11.976 -1.4303 5.33395 5.94475C2.73465 8.83099 1.14036 12.4817 0.790005 16.35C0.712945 17.1807 1.32387 17.9165 2.15452 17.9935C2.19952 17.9977 2.24473 17.9999 2.29001 18C3.05027 18.0097 3.69298 17.4392 3.77348 16.683C4.46548 8.9444 10.9449 3.01071 18.7144 3.00051Z",
    fill: "#030311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1403 18C34.3801 17.9903 33.7373 18.5609 33.6568 19.317C32.9411 27.5583 25.6799 33.659 17.4384 32.9432C13.8726 32.6335 10.5356 31.0571 8.03169 28.4996H12.7146C13.543 28.4996 14.2145 27.8281 14.2145 26.9997C14.2145 26.1713 13.543 25.4998 12.7146 25.4998H6.50026C4.96271 25.4989 3.71569 26.7447 3.71484 28.2822C3.71484 28.2832 3.71484 28.2841 3.71484 28.2852V34.4995C3.71484 35.3279 4.38638 35.9994 5.21477 35.9994C6.04317 35.9994 6.7147 35.3279 6.7147 34.4995V31.3826C14.0898 38.0246 25.4528 37.4303 32.0948 30.0553C34.6941 27.169 36.2884 23.5183 36.6388 19.6499C36.7158 18.8193 36.1049 18.0835 35.2743 18.0064C35.2298 18.0023 35.185 18.0001 35.1403 18Z",
    fill: "#030311"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5393_11034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.714355)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.716d5151a4b635107b25c03e1cd0a507.svg";
export { ForwardRef as ReactComponent };